import { compact, values } from 'lodash-es';
import type { DateOnly } from '../utils';

/** For entities that are subject to some fixing, either single token or multitoken */
export interface FixingDetails {
  /** Single-token fixing index */
  Index?: string;
  /** The fixing price applied */
  Fixing?: string;
  /** The date of fixing (DateOnly) for the record */
  FixingDate?: DateOnly;

  /** Fixing details per symbol for multitoken entities. Indexed by symbol (eg "BTC-USD") */
  MultilegFixingDetails?: { [key: string]: { Index: string; Fixing?: string; FixingDate?: DateOnly } };
}

export function getFixingIndicesList(fixingDetails: FixingDetails | undefined): string[] | undefined {
  if (!fixingDetails) {
    return undefined;
  }

  if (fixingDetails?.MultilegFixingDetails) {
    return compact(values(fixingDetails.MultilegFixingDetails).map(value => value.Index));
  } else {
    return compact([fixingDetails?.Index]);
  }
}
